import { render } from "./Yhzh.vue?vue&type=template&id=4adea029"
import script from "./Yhzh.vue?vue&type=script&lang=js"
export * from "./Yhzh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__